import { useState } from 'react';
import { Add } from '@material-ui/icons';
import { TicketMetrics } from './TicketMetrics';
import { TotalTickets } from './TotalTickets';
import { CreateTicketModal } from '../CreateTicket/CreateTicketModal';
import { Card } from '../../../components/Card';
import { Button } from '../../../components/Button/NewButton';
import { useUser } from '../../../contexts/UserContext';
import { useOperator } from '../../../contexts/OperatorContext';

interface Props {
  ticketData: any[];
  loading: boolean;
  onCreateTicket(): void;
  selectedMetric: string;
  setSelectedMetric(metric: any): void;
}

export const Header = ({
  ticketData,
  loading,
  onCreateTicket,
  selectedMetric,
  setSelectedMetric,
}: Props) => {
  const [createTicketOpen, setCreateTicketOpen] = useState(false);
  const operator = useOperator();
  const user = useUser();

  return (
    <Card className="block min-w-[300px] min-h-[120px]" fullWidth>
      <TotalTickets totalTickets={ticketData.length} loading={loading} />
      <div className="grid grid-cols-1 lg:grid-cols-6 items-center w-full">
        <TicketMetrics
          ticketData={ticketData}
          loading={loading}
          selectedMetric={selectedMetric}
          setSelectedMetric={setSelectedMetric}
        />
        {(operator.type === 'Hospitality' &&
          user.permissions.canHosSupportCreate) ||
        (operator.type === 'Residential' &&
          user.permissions.canResSupportCreate) ? (
          <div className="p-6 w-full">
            <Button
              fullWidth
              startIcon={<Add fontSize="small" />}
              onClick={() => setCreateTicketOpen(true)}
            >
              New Ticket
            </Button>
          </div>
        ) : null}
      </div>
      <CreateTicketModal
        open={createTicketOpen}
        onClose={() => setCreateTicketOpen(false)}
        onCreateTicket={onCreateTicket}
      />
    </Card>
  );
};
